import styled from 'styled-components';
export const ToolCatalogItemStyled = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
`;
export const ToolCatalogListStyled = styled.div`
  width: 100%;
  height: calc(100vh - 170px);
  overflow-y: auto;
`;
